import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import { useConfigContext } from '../../../ui-config'
import { HistoryNode } from '../../common/interface'
import { DataHistoryDelFor } from './model'

export function useDeliveryForecastHistory(): FetchResult<
  HistoryNode<DataHistoryDelFor>[]
> {
  const { pollingConfig } = useConfigContext()
  const { data, isLoading, error, mutate } = useSWR<
    FetchResponse<HistoryNode<DataHistoryDelFor>[]>,
    FetchError
  >(`/history/deliveryforecasts`, fetchJson<HistoryNode<DataHistoryDelFor>[]>, {
    refreshInterval: pollingConfig.intervalInSeconds * 1000,
  })

  return {
    data: data?.body,
    isLoading: isLoading,
    error: error,
    mutate: mutate,
    etag: data?.etag,
  }
}
